import { useNavigate, useParams } from "react-router-dom";
import MovimentacaoForm, { IMovimentacaoFormProps } from "../../Conta/Movimentacao/MovimentacaoForm";
import { Button, Result } from "antd";

export interface ITituloMovimentacaoFormProps extends IMovimentacaoFormProps {
    codTitulo?:number;
}

export default function TituloMovimentacaoForm({
    codTitulo : codTituloParam,
    ...props
}:ITituloMovimentacaoFormProps) {
    const navigate = useNavigate();
    const { codigo : codTituloRota } = useParams();

    const codTitulo = (codTituloParam === undefined || isNaN(codTituloParam) ? Number.parseInt(codTituloRota ?? '-1') : codTituloParam) ?? -1;
    
    return codTitulo <= 0 && <Result 
        status="error"
        subTitle="Desculpe, não foi possível identificar o titulo relacionado a movimentação."
        extra={<Button type="primary" onClick={() => navigate(-1)}>Voltar</Button>}
    /> || <MovimentacaoForm 
        {...props} 
        initialValues={{
            ...props?.initialValues,
            movimentacao : {
                ...props?.initialValues?.movimentacao,
                codTitulo : codTitulo
            }
        }}
    />;
}